import React from "react";
import {
    Grid,
    Button,
    Divider,
    Typography,
    Box,
} from "@material-ui/core";
import { useStyles } from "./styles";
import clsx from "clsx";

const ActionForm = ({ handleSubmit, handleCancel, handleSave, icon, primaryText, secondaryText, children, edit, isValid}) => {
    const classes = useStyles(); 

    return (        
        <Box className={clsx(classes.drawerContainer)} display="flex" flexDirection="column" height="100%">
            <Grid container>
                <Grid item xs={1}>
                    <Typography variant="h5" className={clsx(classes.actionIcon)}>{icon}</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Typography variant="h5" className={clsx(classes.actionHeader)}>{primaryText}</Typography>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={11}>
                    <Typography variant="subtitle1" className={clsx(classes.actionText)}>{secondaryText}</Typography>
                </Grid>
            </Grid>

            <form
                className={clsx(classes.form)}
                onSubmit={handleSubmit(handleSave)}
                noValidate
                style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
            >
                <Box mx={-2}>
                    <Divider />
                </Box>

                <Box flexGrow={1}>
                    {children}
                </Box>
                <Box mx={-2}>
                    <Divider />
                </Box>
                <Box className={clsx(classes.actionContainer)} display="flex" justifyContent="space-between">
                    <Button
                        color="primary"
                        data-id="saveBtn"
                        name="Save"
                        disabled={isValid === false}
                        type="submit"
                        variant="contained"
                        aria-label={edit ? "Save" : "Add"}
                        className={clsx("saveBtn", classes.btnControl)}
                    >
                        {edit ? "Save" : "Add"}
                    </Button>
                    <Button
                        className={clsx("cancelBtn", classes.btnControl)}
                        data-id="cancelBtn"
                        name="cancel"
                        variant="contained"
                        aria-label="Close"
                        onClick={handleCancel}
                    >
                        Close
                    </Button>
                </Box>
            </form>
        </Box>
    );
};
export default ActionForm;
